import { render } from "./GroupEditComponent.vue?vue&type=template&id=4fe8419e"
import script from "./GroupEditComponent.vue?vue&type=script&lang=js"
export * from "./GroupEditComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__